import { render } from "./TenantLanding.vue?vue&type=template&id=a6eedb44&scoped=true"
import script from "./TenantLanding.vue?vue&type=script&lang=js"
export * from "./TenantLanding.vue?vue&type=script&lang=js"

import "./TenantLanding.vue?vue&type=style&index=0&id=a6eedb44&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6eedb44"]])

export default __exports__